import { useTranslation } from "react-i18next";
import type { UpgradePromptViewModel } from "./UpgradePrompt.ViewModel.types";

export interface UpgradePromptText {
  title: string;
  body: string;
  seePlans: string;
  notNow: string;
  close: string;
}

export const useUpgradePromptText = (vm: UpgradePromptViewModel): UpgradePromptText => {
  const { t } = useTranslation();
  const plan = vm.planCode ? t(`billing.plans.${vm.planCode}`) : "";

  const title = (): string => {
    if (vm.isUnavailable) return t("billing.upgrade.unavailableTitle");
    if (vm.limitKind === "boards") return t("billing.upgrade.boardsTitle", { plan, count: vm.max ?? 0 });
    if (vm.sourceName && plan) return t("billing.upgrade.sourceTitle", { source: vm.sourceName, plan });
    return t("billing.upgrade.sourcesTitle");
  };

  const body = (): string => {
    if (vm.isUnavailable) return t("billing.upgrade.unavailableBody");
    if (vm.limitKind === "boards") return t("billing.upgrade.boardsBody");
    return t("billing.upgrade.sourcesBody");
  };

  return {
    title: title(),
    body: body(),
    seePlans: t("billing.upgrade.seePlans"),
    notNow: t("billing.upgrade.notNow"),
    close: t("common.actions.close"),
  };
};
